import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventorySuppliers } from '@/renderer/services/inventorySupplierService';
import type { InventorySupplierFilterParams } from '@/renderer/types/inventory';

export function useInventorySuppliers(params: InventorySupplierFilterParams) {
  return useQuery({
    queryKey: queryKeys.inventory.suppliersList(params),
    queryFn: async () => {
      const result = await fetchInventorySuppliers(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch inventory suppliers');
      }

      return result.data;
    },
    enabled: !!params.companyId,
    placeholderData: keepPreviousData,
  });
}
